import Base from './document_package_rule_select_base_controller';

const ACTIVE_PARENT_CLASS = 'bg-black-50';

export default class extends Base {
  static targets = [
    ...Base.targets,
    'hiddenInputs',
    'search',
    'typeList',
    'parentRow',
    'subList',
    'subListLabel',
    'subRowTemplate',
  ];

  filter(event) {
    this.filterRows(this.parentRowTargets, event.target.value || '');
    this.filterRows(this.subListTarget.querySelectorAll('[role="option"]'), event.target.value || '');
  }

  selectParent(event) {
    if (!this.directionPicked()) return;

    const row = event.currentTarget;
    const parentId = row.dataset.parentId;
    const hasChildren = row.dataset.hasChildren === 'true';

    if (hasChildren) {
      this.openSubList(parentId, row);
    } else {
      this.toggleValue(parentId);
    }
  }

  openSubList(parentId, parentRow) {
    this.subListTarget.innerHTML = '';

    const children = this.childrenForParent(parentId);
    children.forEach((child) => {
      this.subListTarget.appendChild(this.buildSubRow(child));
    });

    this.subListLabelTarget.classList.remove('hidden');
    this.subListTarget.classList.remove('hidden');

    this.parentRowTargets.forEach((row) => row.classList.remove(ACTIVE_PARENT_CLASS));
    if (parentRow) parentRow.classList.add(ACTIVE_PARENT_CLASS);
  }

  buildSubRow(child) {
    const fragment = this.subRowTemplateTarget.content.cloneNode(true);
    const row = fragment.querySelector('[role="option"]');
    row.dataset.value = child.id;
    row.dataset.label = child.label;

    row.querySelector('[data-role="label"]').textContent = child.label;

    row.addEventListener('click', () => {
      if (!this.directionPicked()) return;
      this.toggleValue(child.id);
    });

    return row;
  }

  childrenForParent(parentId) {
    return Array.from(
      this.hiddenInputsTarget.querySelectorAll(
        `input[type="checkbox"][data-parent-id="${CSS.escape(parentId)}"]`,
      ),
    ).map((input) => ({ id: input.value, label: input.dataset.label }));
  }

  toggleValue(value) {
    const checkbox = this.checkboxFor(value);
    this.setCheckboxChecked(checkbox, !checkbox?.checked);
  }

  checkboxFor(value) {
    return this.hiddenInputsTarget.querySelector(
      `input[type="checkbox"][value="${CSS.escape(value)}"]`,
    );
  }
}
